module.exports = __webpack_public_path__ + "static/media/co-funded-by-horizon2020-eu-horizontal.1af71560.png";